exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pane{padding:20px;position:absolute;height:calc(100% - 80px);overflow:auto;top:80px;right:0;background:#4d88d6;width:300px;z-index:11001}.pane h1{margin-top:10px;margin-bottom:20px;color:#fff;font-size:18px}@media screen and (max-width:720px){.pane{height:calc(100vh - 50px);top:50px;width:50%}}.part{background:#fff;width:100%;padding:10px;margin-bottom:20px}.part h2{color:#4d88d6;font-size:16px;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/styles/_panes.less
// module id = 907
// module chunks = 0